import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "@/lang/en.json";
import twLocale from "@/lang/tw.json";

Vue.use(VueI18n);

const messages: any = {
  en: {
    ...enLocale,
  },
  tw: {
    ...twLocale,
  }
};

const language = "en";

const i18n = new VueI18n({
  locale: language,
  messages,
});

export default i18n;
